// tslint:disable-next-line:no-empty-interface
export interface StoryPlayerViewModel {
}

export class StoryPlayerViewModel {
    constructor(init?: StoryPlayerViewModel) {
        Object.assign(this, init);
    }
}
